import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-model-decription',
  templateUrl: './model-decription.component.html',
  styleUrls: ['./model-decription.component.scss']
})
export class ModelDecriptionComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,public dialogRef: MatDialogRef<ModelDecriptionComponent>) {}

  ngOnInit(): void {
    
  }
  close(){
    this.dialogRef.close()
  }
}
